import React, { Component } from "react";
import styles from "./../reportTable.module.scss";
import { withReportsList } from "../../../shared/containers/containerReportsList";
import Scrollbars from "react-custom-scrollbars-2";

class GeoZoneByDayHeader extends Component {
  getHedeaderItem(item, index) {
    return (
      <div
        key={index}
        className={styles.reportTableHeaderItem}
        style={{
          width: item.cssColumnWidth + "px",
        }}
      >
        {item.dashboard.title} {item.dashboard.measure !== null ? `(${item.dashboard.measure}.)` : null}
      </div>
    );
  }

  render() {
    const { reportsListData } = this.props;

    const report = reportsListData.filter((x) => {
      return x.buildType === 14 && x.reportType === 4;
    })[0];

    if (report === undefined) return <div></div>;

    return (
      <div>
        <Scrollbars style={{ height: 120 + "px" }} autoHide={false} ref="scrollbarHeader">
          <div className={styles.reportTableHeaderContainer}>
            {report.fields.map((item, index) => {
              return this.getHedeaderItem(item, index);
            })}
          </div>
        </Scrollbars>
      </div>
    );
  }
}

export default withReportsList(React.memo(GeoZoneByDayHeader));
